import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-a2c35ca2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "inner" }
const _hoisted_3 = {
  class: "tabsHeader",
  role: "tablist"
}
const _hoisted_4 = ["aria-selected", "onClick"]

import { provide, useSlots, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Tabs',
  setup(__props) {

const slots = useSlots();
const tabTitles = ref(slots.default!().map((tab) => tab.props!.title));
const selectedTitle = ref(tabTitles.value[0]);
provide('SelectedTitle', selectedTitle);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabTitles.value, (title) => {
            return (_openBlock(), _createElementBlock("button", {
              key: title,
              role: "tab",
              "aria-selected": selectedTitle.value === title,
              class: _normalizeClass(["tabsItem", { panelActive: selectedTitle.value === title }]),
              onClick: ($event: any) => (selectedTitle.value = title)
            }, _toDisplayString(title), 11, _hoisted_4))
          }), 128))
        ])
      ])
    ]),
    _renderSlot(_ctx.$slots, "default")
  ], 64))
}
}

})